export const navTextSize: string = "1.5rem"
